// A custom fetch implementation to get the file upload progress and
// abort file uploads.
// https://github.com/jaydenseric/apollo-upload-client/issues/88

const parseHeaders = (
  rawHeaders: string
): Headers | string[][] | { [key: string]: string } => {
  const headers = new Headers();
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  const preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
  preProcessedHeaders.split(/\r?\n/).forEach((line) => {
    const parts = line.split(":");
    const key = parts.shift()?.trim();
    if (key) {
      const value = parts.join(":").trim();
      headers.append(key, value);
    }
  });
  return headers;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const uploadFetch = (url: string, options) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const opts: ResponseInit & { url?: string } = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || ""),
      };

      if ("responseURL" in xhr) {
        opts.url = xhr.responseURL;
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        opts.headers?.get("X-Request-URL");
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const body = "response" in xhr ? xhr.response : xhr.responseText;
      resolve(new Response(body, opts));
    };
    xhr.onerror = () => {
      reject(new TypeError("Network request failed"));
    };
    xhr.ontimeout = () => {
      reject(new TypeError("Network request failed"));
    };
    xhr.open(options.method, url, true);

    Object.keys(options.headers).forEach((key) => {
      xhr.setRequestHeader(key, options.headers[key]);
    });

    if (xhr.upload && options.onProgress) {
      xhr.upload.onprogress = options.onProgress;
    }

    options.onAbortPossible &&
      options.onAbortPossible(() => {
        xhr.abort();
      });

    xhr.send(options.body);
  });

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const customFetch = (uri, options): Promise<Response | unknown> => {
  if (options.useUpload) {
    return uploadFetch(uri, options);
  }
  return fetch(uri, options);
};

export default customFetch;
